if (!customElements.get("seen-on-feed-slider")) {
  class SeenOnFeedSlider extends HTMLElement {
    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      this.slider = this.querySelector(".swiper");

      const enableAutoscroll = this.hasAttribute("data-autoscroll");
      const autoscrollDelay =
        Number(this.getAttribute("data-autoscroll-delay")) || 3000;

      const swiperOptions = {
        slidesPerView: "auto",
        spaceBetween: 9,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        loop: true,
        grabCursor: true,
        cssMode: false,
        watchOverflow: true,

        breakpoints: {
          769: {
            spaceBetween: 14,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            centeredSlides: true,
          },
        },
      };

      if (enableAutoscroll) {
        swiperOptions.freeMode = false;
        swiperOptions.loop = true;
        swiperOptions.autoplay = {
          delay: autoscrollDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      this.swiper = new Swiper(this.slider, swiperOptions);
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("seen-on-feed-slider", SeenOnFeedSlider);
}
